import { solutionsStore } from 'src/pages/Solutions';

export default [...solutionsStore.middlewares];
